module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#bundle",
      toString: function () {
        return this.url;
      }
    }